export enum LanguageEnum {
  SK = 'sk',
  EN = 'en',
}
